import { ProfilePhotoFallback } from 'src/shared/features/users/components/profile-photos/profile-avatar'

type BorderedProfilePhotoProps = {
  uri: string | null
  size?: number
  borderWidth?: number
}

const BorderedProfilePhoto = ({ uri, size = 45, borderWidth = 2 }: BorderedProfilePhotoProps) => {
  const totalSize = size + borderWidth * 2

  return (
    <div
      className="flex items-center justify-center rounded-full border-solid border-white bg-lightBorder shadow-[0_2px_12px_rgba(27,48,41,0.1)]"
      style={{ width: totalSize, height: totalSize, borderWidth }}
    >
      <img
        src={uri || ProfilePhotoFallback}
        alt=""
        className="rounded-full object-cover"
        style={{ width: size, height: size }}
      />
    </div>
  )
}

export default BorderedProfilePhoto
